<script lang="ts">
  import type { ApiField } from '../../data-tables-api';

  let {
    field,
    value,
    onChange,
    error,
    disabled = false,
  }: {
    field: ApiField;
    value: unknown;
    onChange: (v: unknown) => void;
    error?: string | null;
    disabled?: boolean;
  } = $props();

  /** Зберігаємо у БД як integer cents. UI працює у major-одиницях. */
  const major = $derived(value != null ? String(Number(value) / 100) : '');

  function handle(raw: string) {
    if (raw === '') {
      onChange(null);
      return;
    }
    const n = Number(raw);
    if (!Number.isFinite(n)) {
      onChange(null);
      return;
    }
    onChange(Math.round(n * 100));
  }
</script>

<div class="relative">
  <input
    type="number"
    step="0.01"
    value={major}
    oninput={(e) => handle((e.target as HTMLInputElement).value)}
    required={field.required}
    {disabled}
    class="w-full rounded-md border px-3 py-2 pl-8 text-sm focus:outline-none focus:ring-1 focus:ring-[var(--color-pu)] {error ? 'border-red-400' : 'border-[var(--color-border-3)]'}"
  />
  <span class="absolute left-3 top-1/2 -translate-y-1/2 text-xs text-[var(--color-text-muted)]">₴</span>
</div>
{#if error}
  <div class="mt-1 text-[11px] text-red-600">{error}</div>
{/if}
